export const SALES_DOCUMENT_COLUMN_DEFAULTS = {
  invoice: {
    reference: true,
    total: true,
    amount_paid: true,
    status: true,
    order: true,
    client: true,
    date: true,
    due_date: true,
    created_by: true,
    action: true
  },
  quote: {
    reference: true,
    client: true,
    total_products: true,
    total: true,
    date: true,
    status: true,
    created_by: true,
    action: true
  },
  delivery: {
    reference: true,
    order: true,
    client: true,
    status: true,
    date: true,
    created_by: true,
    action: true
  }
}

export const SALES_DOCUMENT_COLUMN_LABELS = {
  reference: 'reference',
  total: 'total',
  amount_paid: 'amount_paid',
  status: 'status',
  order: 'order',
  client: 'client',
  date: 'date',
  due_date: 'due_date',
  created_by: 'created_by',
  total_products: 'total_products',
  action: 'action'
}

export function getSalesDocumentColumnDefaults(documentType) {
  return { ...(SALES_DOCUMENT_COLUMN_DEFAULTS[documentType] || {}) }
}

export function getSalesDocumentColumnMetadataKey(documentType) {
  return `sales_${documentType}_columns`
}
